<template>
<div class="container-fluid" id="app">
  <div class="row" id="">
    <NavBar :prop="trigger"/>
    
  </div>
  <div class="row">
      <router-view @NavSetter="OnChangedVal"/>
  </div>
  
  <div class="row">
    <Footer />
  </div>
</div>
  
</template>

<script lang="ts">
import { Options, Vue } from "vue-class-component";
import NavBar from "@/components/Nav/NavBar.vue"; // @ is an alias to /src
import Footer from "@/components/Footer/Footer.vue";
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
@Options({
  components: {
    NavBar,
    Footer,
    FontAwesomeIcon  },
})
export default class App extends Vue {
  trigger=""
  OnChangedVal(){
    this.trigger=Math.random().toString()
  }
}
</script>

<style>
#app {
  font-family: Alata, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}
</style>

